/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, xcss } from '@atlaskit/primitives';

import { CloseButton } from './close-button';
import { Title } from './title';

interface HeaderProps {
	closeButtonRef?: React.RefObject<HTMLButtonElement | null>;
	hasError: boolean;
	onClose?(): void;
	showDropShadow: boolean;
	title?: string;
	titleComponent?: React.ReactNode;
}

const inlineStyles = xcss({
	zIndex: 'navigation',
	paddingBottom: 'space.300',
	paddingTop: 'space.400',
	marginLeft: 'space.400',
	marginRight: 'space.400',
});

// css() required to do custom boxShadow
const scrolledStyles = css({
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
	boxShadow: '0px 8px 14px -14px rgba(0, 0, 0, 0.4)',
});

export const Header = ({
	title,
	hasError,
	showDropShadow,
	onClose,
	titleComponent,
	closeButtonRef,
}: HeaderProps): React.JSX.Element => {
	const titleContent = titleComponent ? titleComponent : <Title>{title}</Title>;

	return (
		<div css={[showDropShadow && scrolledStyles]}>
			<Inline alignBlock="start" spread="space-between" space="space.200" xcss={inlineStyles}>
				{!hasError ? titleContent : <div />}
				<CloseButton onClose={onClose} ref={closeButtonRef} />
			</Inline>
		</div>
	);
};
